export default "__VITE_ASSET__DS0Ow49$__"